export default "__VITE_ASSET__CzAOTjGs__"